import {Flex, Text} from '@chakra-ui/react';
import {colors} from 'components/providers';
import {useTranslation} from 'hooks';
import {FC} from 'react';

import {OrderTotalListItem} from '..';

interface IProps {
  voucher: any;
}

export const CostPromoCode: FC<IProps> = ({voucher}) => {
  const {t} = useTranslation();

  if (!voucher || !voucher.is_valid) {
    return null;
  }

  const promoCodeText = voucher?.promoCode;
  const reductionText = voucher?.reduction;

  return (
    <OrderTotalListItem title={`${t('VOUCHER')} `}>
      <Flex justifyContent="space-between" alignItems="center" w="100%" ml="10px">
        <Text as="span" fontWeight="700">
          {promoCodeText}
        </Text>
        {!!reductionText && (
          <Text as="span" fontWeight="500" color={colors.green}>
            {`-${reductionText} ${t('CURRENCY')}`}
          </Text>
        )}
      </Flex>
    </OrderTotalListItem>
  );
};
